import { GlobalRouter } from '@routers/GlobalRouters';
import { BrowserRouter as Router } from 'react-router-dom';

const App = () => {
  return (
    <Router>
      <GlobalRouter />
    </Router>
  );
};

export default App;
